import { Resume } from '@sr/types';
import Sections from '../common/Sections';
import { Box } from '../common/ui';
import BlockListSection from './BlockListSection';
import DetailSection from './DetailSection';
import Header from './Header';
import InlineListSection from './InlineListSection';
import theme from './san-juan-theme';

const SanJuan = ({ resume }: { resume: Resume }) => {
  const fontStyle = resume.style.customizations['san-juan']?.fontStyle;
  return (
    <>
      {fontStyle !== 'technical' && fontStyle !== 'classic' && (
        <link rel="stylesheet" href="https://use.typekit.net/kpf8pfn.css" />
      )}
      {fontStyle === 'technical' && (
        <link
          href="https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@400;500&display=swap"
          rel="stylesheet"
        />
      )}
      {fontStyle === 'classic' && (
        <link
          href="https://fonts.googleapis.com/css2?family=Lora:wght@400;700&display=swap"
          rel="stylesheet"
        />
      )}
      <Header resume={resume} />
      <Box className="pdf-page-container">
        <Box className="pdf-page-column">
          <Sections
            resume={resume}
            filter="all"
            DetailSection={DetailSection}
            BlockListSection={BlockListSection}
            InlineListSection={InlineListSection}
          />
        </Box>
      </Box>
    </>
  );
};

SanJuan.theme = theme;
export default SanJuan;
